(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_section-flex-pdp-personalization"] && !Shopify.designMode) return;
  try {
    (function () {
    var NOTE_START = '--- Personalization ---';
    var NOTE_END = '--- End Personalization ---';

    function setSubsDisabled(root, disabled) {
      root.querySelectorAll('[data-p13n-sub]').forEach(function (el) {
        el.disabled = disabled;
        if (disabled) {
          el.checked = false;
        }
      });
    }

    function resetLines(root) {
      var lines = root.querySelector('[data-p13n-lines]');
      var inputs = root.querySelectorAll('[data-p13n-line]');
      if (lines) lines.hidden = true;
      inputs.forEach(function (inp) {
        inp.disabled = true;
        inp.value = '';
      });
    }

    function onMasterChange(root, checked) {
      var panel = root.querySelector('[data-p13n-panel]');
      if (!panel) return;
      if (checked) {
        panel.hidden = false;
        setSubsDisabled(root, false);
      } else {
        panel.hidden = true;
        setSubsDisabled(root, true);
        resetLines(root);
      }
    }

    document.addEventListener('change', function (e) {
      var el = e.target;
      if (!(el instanceof HTMLInputElement)) return;

      var root = el.closest('[data-flex-pdp-personalization]');
      if (!root) return;

      if (el.matches('[data-p13n-master]')) {
        onMasterChange(root, el.checked);
        return;
      }

      if (!el.matches('[data-p13n-sub]')) return;

      var removeText = root.querySelector('[data-p13n-remove-text]');
      var personalizeText = root.querySelector('[data-p13n-personalize-text]');
      var lines = root.querySelector('[data-p13n-lines]');
      var lineInputs = root.querySelectorAll('[data-p13n-line]');

      if (removeText && el === removeText && removeText.checked && personalizeText) {
        personalizeText.checked = false;
        if (lines) lines.hidden = true;
        lineInputs.forEach(function (inp) {
          inp.disabled = true;
          inp.value = '';
        });
      }

      if (personalizeText && el === personalizeText && personalizeText.checked && removeText) {
        removeText.checked = false;
        if (lines) lines.hidden = false;
        lineInputs.forEach(function (inp) {
          inp.disabled = false;
        });
      }

      if (personalizeText && el === personalizeText && !personalizeText.checked) {
        if (lines) lines.hidden = true;
        lineInputs.forEach(function (inp) {
          inp.disabled = true;
          inp.value = '';
        });
      }
    });

    function labelFromPropertiesName(name) {
      if (!name) return '';
      var m = name.match(/^properties\[(.+)\]$/);
      return m ? (m[1] || '').trim() : '';
    }

    function buildPersonalizationSummary(root) {
      if (!root) return '';

      var lines = [];
      var inputs = root.querySelectorAll('input[name^="properties["], textarea[name^="properties["], select[name^="properties["]');

      inputs.forEach(function (el) {
        if (!(el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement || el instanceof HTMLSelectElement)) return;
        if (el.disabled) return;

        var label = labelFromPropertiesName(el.getAttribute('name')) || el.getAttribute('aria-label') || '';
        if (!label) return;

        if (el instanceof HTMLInputElement && (el.type === 'checkbox' || el.type === 'radio')) {
          if (!el.checked) return;
          var v = (el.value || 'Yes').trim();
          lines.push(label + ': ' + v);
          return;
        }

        var value = (el.value || '').trim();
        if (!value) return;
        lines.push(label + ': ' + value);
      });

      // Only show anything if the main toggle is checked (prevents stray empty lines).
      var master = root.querySelector('[data-p13n-master]');
      if (master instanceof HTMLInputElement && !master.checked) return '';

      return lines.join('\n');
    }

    function replaceNoteBlock(note, blockText) {
      var current = (note || '').trim();
      var out = current;

      // Remove existing personalization block if present
      var startIdx = out.indexOf(NOTE_START);
      var endIdx = out.indexOf(NOTE_END);
      if (startIdx !== -1 && endIdx !== -1 && endIdx > startIdx) {
        out = (out.slice(0, startIdx) + out.slice(endIdx + NOTE_END.length)).trim();
      }

      if (blockText && blockText.trim()) {
        var spacer = out ? '\n\n' : '';
        out = (out + spacer + NOTE_START + '\n' + blockText.trim() + '\n' + NOTE_END).trim();
      }

      return out;
    }

    function syncCartNoteFromProduct() {
      if (!window.theme || !theme.cart || typeof theme.cart.getCart !== 'function' || typeof theme.cart.updateNote !== 'function') return;

      var root = document.querySelector('[data-flex-pdp-personalization]');
      if (!root) return;

      var summary = buildPersonalizationSummary(root);
      if (!summary) return; // only add to cart note if something is actually selected/filled

      theme.cart.getCart().then(function (cart) {
        var existing = cart && cart.note ? cart.note : '';
        var next = replaceNoteBlock(existing, summary);
        if (next !== (existing || '').trim()) {
          theme.cart.updateNote(next);
        }
      }).catch(function () {});
    }

    // When product is added via ajax, copy personalization selections into cart note
    document.addEventListener('product-form:submit:success', function () {
      syncCartNoteFromProduct();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
